import type { MerchantReturnPolicy, OfferShippingDetails } from 'schema-dts'
import type { ShippingCost } from '~/composables/types/cart'
import { getSchemaReturnPolicy } from '~/utils/schemaOrgHelpers'

const getCountryCode = (cost: ShippingCost) => cost.country?.data?.codeIsoAlpha2

/**
 * One entry per country the kit ships to, priced from the kit's own shipping
 * costs (the same ones the cart charges). No delivery time: the kit page
 * doesn't promise one.
 */
export const getKitShippingDetails = (
  costs: ShippingCost[]
): OfferShippingDetails[] =>
  costs
    .filter((cost) => getCountryCode(cost) && cost.value?.currency)
    .map((cost) => ({
      '@type': 'OfferShippingDetails',
      shippingRate: {
        '@type': 'MonetaryAmount',
        value: Number(cost.value.amount) / 100,
        currency: cost.value.currency,
      },
      shippingDestination: {
        '@type': 'DefinedRegion',
        addressCountry: getCountryCode(cost)!,
      },
    }))

/** The return policy for the countries the kit ships to. */
export const getKitReturnPolicy = (
  costs: ShippingCost[]
): MerchantReturnPolicy | undefined => {
  const countries = [
    ...new Set(costs.map(getCountryCode).filter(Boolean) as string[]),
  ]
  return countries.length ? getSchemaReturnPolicy(countries) : undefined
}
